import { useCallback } from "react";
import { useIntl } from "react-intl";
import { useAuthContext } from "../context/AuthContext";
import usersService from "../services/users.service";
import useAsyncSelectFormInput from "./useAsyncSelectFormInput";
import { ManageUsersActionType, useManageUsersContext } from '../context/ManageUsersContext';

const useLoadDomains = () => {
  const intl = useIntl();

  const domainPlaceholder = intl.messages[
    "MANAGEMENT.USER_DETAILS.SELECT_DOMAIN"
  ] as string;

  const {
    state: { user },
  } = useAuthContext();

  const { state: { selectedUser, emailDomains }, dispatch} = useManageUsersContext();

  const loadItems = useCallback(async () => {
    if (!user?.organization?.id) return [];
    if (emailDomains) return emailDomains;

    const emailDomainsRes = await usersService.getOrgEmailDomains();

    const mapEmailDomains = emailDomainsRes?.map((domain) => ({
      key: domain.domain,
      value: domain.domain,
    })) || [];

    dispatch({
      type: ManageUsersActionType.SET_EMAIL_DOMAINS,
      payload: mapEmailDomains,
    });

    return mapEmailDomains;
  }, [user?.organization?.id, dispatch, emailDomains]);

  const { selectItems: domains } = useAsyncSelectFormInput(
    loadItems,
    domainPlaceholder,
  );

  const extractSelectedUserDomain = () => {
    const domain = selectedUser?.email?.split('@')[1];
    if (!domain) return;
    return {
      key: domain,
      value: domain,
    };
  }

  return { domains, domainPlaceholder, userDomain: extractSelectedUserDomain() };
};

export default useLoadDomains;
